<script lang="ts">

    export let content;

    $: divTable = null;
   
    $: if (content && divTable) {
        divTable
            .querySelectorAll("table")
            .forEach(function (table) {
                let lastRow;
                let perRow = -1;
                table.querySelectorAll("tr").forEach(function (row) {
                    row.querySelectorAll("td").forEach(function (
                        cell,
                        cellIndex
                    ) {
                        if(perRow ==-1){
                            perRow = row.childElementCount
                        }
                        if (cellIndex == 3 && !lastRow || lastRow && lastRow.childElementCount == 4) {
                            lastRow = row;
                        }
                        if (cell.textContent.trim().length == 0) {
                            cell.parentNode.removeChild(cell);
                        } else {
                            if (lastRow && lastRow.childElementCount < 4) {
                                lastRow.append(cell);
                            }
                        }
                    });
                });
            });
    }

    let selectedImage = "";

    function handleClick(e) {
        selectedImage = e.target.src;
    }
</script>

<svelte:head>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap" rel="stylesheet">
</svelte:head>

<div class="gallery">
    <div bind:this={divTable} on:click={handleClick}>
        {@html content}
    </div>
    {#if selectedImage}
        <div
            on:click={() => {
                selectedImage = "";
            }}
            id="selected-image-view"
        >
            <img src={selectedImage} alt="noImage" />
        </div>
    {/if}
</div>

<style>
    .gallery {
        width: 100%;
        padding: 10px 0px;
    }

    :global(.gallery br) {
        display: none !important;
    }

    :global(.gallery img) {
        cursor: pointer;
        width: 100%;
    }

    :global(.gallery h3) {
        font-family: 'Roboto', sans-serif !important;
        font-size: large;
        font-weight: bold;
        padding: 0px 0px;
    }

    :global(.gallery table) {
        border-collapse: separate;
    }

    :global(.gallery td) {
        margin: 5px;
        border: none;
        outline: rgb(59, 59, 59) solid 1px !important;
        display: inline-block;
        background-color: rgb(59, 59, 59) !important;
        padding: 0px !important;
    }

    #selected-image-view {
        position: fixed;
        vertical-align: middle;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.938);
    }

    @media (min-width: 640px) {
        .gallery {
            grid-template-columns: auto auto auto auto;
            padding: 0px 0px;
        }

        :global(.gallery table) {
            border-collapse: separate;
            border-spacing: 20px 20px !important;
            table-layout: fixed;
        }

        :global(.gallery td) {
            margin: 20px;
            border: none;
            outline: rgb(59, 59, 59) solid 1px !important;
            max-width: 1%;
            display: table-cell;
            background-color: rgb(59, 59, 59) !important;
            padding: 0px !important;
        }

        :global(.gallery h1) {
            font-size: 26px;
            padding-top: 10px;
        }

        #selected-image-view img {
            position:absolute;
            width: auto;
            max-width: 55%;
            max-height: 99%;
        }
    }
</style>
